import { Provider } from '@weave/schema-gen-ts/dist/schemas/schedule/v3/provider.pb';
import { contextFactory } from '@frontend/design-system';

export type AddProviderV3ContextType = {
  locationId: string;
  providerDetails: Provider;
  setProviderDetails: (providerDetails: Provider) => void;
  onClose: () => void;
};

export const [AddProviderV3Context, useAddProviderV3Context] = contextFactory<AddProviderV3ContextType>(
  'useAddProviderV3Context must be used within a AddProviderV3Context'
);
